<template>
  <header :class="$style.header">
    <div :class="$style.wrapper">
      <router-link
        :class="$style.logo"
        tag="img"
        to="/"
        :src="url"/>
    </div>
  </header>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'LayoutHeader',
  computed: {
    url() {
      return require(`../assets/GO2Partners2023HorizRGB-WHT.png`);
    },
  },
};
</script>
<style lang="scss"
       module>
@import '../brand/brandColors.variables.scss';

.header {
  background-color: $blue-dark;
  height: 7rem;
}

.wrapper {
  composes: pageContainer from '../brand/structure.scss';
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.logo {
  height: 4rem;
  cursor: pointer;
}
</style>
